import swal from 'sweetalert';
import { baseApiAxios, showError } from './js/portal/api';
import { addToast } from './js/portal/main';
import { removeSearchParamsUrl } from './js/portal/search_params';
import { addButtonSpinner, addSpinner, removeSpinners } from './js/portal/sidebar';
import AccountDropdown from './jsx/components/forms/AccountDropdown';
import DatePickerField from './jsx/components/forms/DatePickerField';
import UserDropdown from './jsx/components/forms/UserDropdown';
import { disableFeatureFlagControlledElements, get_feature_flag_property } from './js/portal/feature_flags';

/**
 * Check if the user has permissions for the selected AWS account to request the temporary purchasing role.
 * If the user has enough permissions, show the rest of the form with all input fields.
 */
function contentVisibilityHandler() {
  // TODO: This check needs to be extended most probably as it does not make sense to hardcode a value to true
  // and check directly afterwards if it's really true :)
  const hasPermission = true;
  if (hasPermission) {
    document.getElementById('submitButton').removeAttribute('disabled');
  } else {
    document.getElementById('request-role-info-container').style.display = '';
  }

  // Show an additional info block if the account belongs to any fs_* account area
  baseApiAxios.getAccount(document.getElementById('account_id').value).then(response => {
    let account_area = response.account_area;
    if (account_area?.startsWith('fs_')) {
      document.getElementById('fs-infobox').removeAttribute('hidden');
    } else {
      document.getElementById('fs-infobox').setAttribute('hidden', true);
    }
  });
}

function getUTCDateText(value) {
  return `${value.toDateString()} ${('0' + value.getUTCHours()).slice(-2)}:${('0' + value.getUTCMinutes()).slice(
    -2,
  )}:00 UTC`;
}

/**
 * Set initial date values
 */
function setInitialDateValues() {
  // Identify the starting date, 3 days in the future from the current date
  const radioValue = document.querySelector('input[name="costs-marketplace-radio"]:checked')?.id || 'not-set';
  let timeToAdd;
  if (radioValue === 'costs-marketplace-upfront') {
    // upfront payment meaning 3 days ahead
    timeToAdd = 3 * 24 * 60 * 60 * 1000;
  } else {
    // not upront payment only one hour ahead,
    // in the backend there is a check that as default check for 30 minutes
    // I add an hour to be sure that the user has enough time to fill the form
    timeToAdd = 1 * 60 * 60 * 1000;
  }

  const startDate = new Date(new Date().getTime() + timeToAdd);
  const startDateValue = startDate.toLocaleDateString('sv');
  const startTimeValue = startDate.toLocaleTimeString('sv').substring(0, 5);

  // Set the start date
  const fieldStartDate = document.getElementById('start_date');
  fieldStartDate.value = startDateValue;
  fieldStartDate.setAttribute('min', startDateValue);

  // Set the start time
  const fieldStartTime = document.getElementById('start_time');
  fieldStartTime.value = startTimeValue;

  const fieldStartDateUtc = document.getElementById('start_date_utc');
  fieldStartDateUtc.innerText = getUTCDateText(startDate);

  // Update the end date, based on the start date
  updateDateValues();
}

/**
 * Update the end date, based on the start date
 */
function updateDateValues() {
  // Collect the start date and time values
  const startDateValue = document.getElementById('start_date').value;
  const startTimeValue = document.getElementById('start_time').value;

  const startDateUtc = new Date(`${startDateValue} ${startTimeValue}`);
  const timezoneOffset = new Date().getTimezoneOffset();
  const startDate = new Date(startDateUtc.getTime() - timezoneOffset * 60 * 1000);

  // Set the start date
  const fieldStartDatePayload = document.getElementById('start_date_utc_payload');
  fieldStartDatePayload.value = startDateUtc.toISOString().replace(/\.\d{3}Z/, 'Z');

  // Set start date UTC text
  const fieldStartDateUtc = document.getElementById('start_date_utc');
  fieldStartDateUtc.innerText = getUTCDateText(startDateUtc);

  // Get the target timespan in hours between the startDate and the target endDate
  const timespanHours = document.getElementById('hours').value;

  // Identify the end date, based on the starting date and the number of hours in the future
  const endDate = new Date(startDate.getTime() + (timespanHours * 60 + timezoneOffset) * 60 * 1000);

  // Set the end date
  const fieldEndDate = document.getElementById('end_date');
  const endDateValue = endDate.toLocaleDateString('sv');
  fieldEndDate.value = endDateValue;
  fieldEndDate.setAttribute('min', endDateValue);

  // Set the end time
  const fieldEndTime = document.getElementById('end_time');
  fieldEndTime.value = endDate.toLocaleTimeString('sv').substring(0, 5);

  // Set end date UTC text
  const fieldEndDateUtc = document.getElementById('end_date_utc');
  fieldEndDateUtc.innerText = getUTCDateText(endDate);
}

function resetFieldValidity(evt) {
  evt.target.setCustomValidity('');
}

export default function MarketplaceRequestRoleAccessPage() {
  let upfrontPayment;

  const questions = {
    Marketplace: {
      mp_1: 'Planned duration of the contract in months?',
    },
  };

  const updateSelectPickers = () => $('.selectpicker').selectpicker('refresh');

  const handleCostsRadioChange = () => {
    const radioValue = document.querySelector('input[name="costs-marketplace-radio"]:checked')?.id || 'not-set';
    disableFormFields(document.getElementById('ekw-container'));
    if (radioValue === 'costs-marketplace-upfront') {
      disableFormFields(document.getElementById('costs-shared'));
      upfrontPayment = true;
      swal({
        text: `Dear Customers,

        Upfront payments present a compliance challenge, create significant additional work, and are only approved, if there is no other option.
        Please join the Walk-in session for AWS Marketplace to discuss your use case and find a solution together with the Cloud Foundation Team.
        For more information on the walk-in session (schedule etc.) please visit this page https://atc.bmwgroup.net/confluence/x/J3eb0gE


        BR,
        Cloud Foundation Team`,
        icon: 'info',
        buttons: {
          reload: {
            text: 'OK',
            value: true,
            visible: true,
          },
        },
      });
    } else {
      enableFormFields(document.getElementById('costs-shared'));
      upfrontPayment = false;
    }
    setInitialDateValues();
  };

  const handleEKWRadioChange = () => {
    const radioValue = document.querySelector('input[name="ekw-number-radio"]:checked').id;
    const textInput = document.getElementById('ekw_number');
    if (radioValue === 'ekw-number-yes') {
      textInput.disabled = false;
    } else {
      textInput.value = '';
      textInput.disabled = true;
    }
  };

  const resetForm = event => {
    const formElement = $('#request-role-acccess-form');
    formElement[0].reset();
    formElement.removeClass('was-validated');
    setInitialDateValues();
    removeSearchParamsUrl();
    document.querySelectorAll('.dynamic-form-element').forEach(field => {
      if (field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });
    updateSelectPickers();
    enableFormFields(document.getElementById('form-reason'));
    $('.selectpicker').val('').selectpicker('deselectAll').selectpicker('refresh');
  };

  const enableFormFields = container => {
    container.classList.remove('d-none');
    container.querySelectorAll('input').forEach(field => {
      field.disabled = false;
    });
    container.querySelectorAll('textarea').forEach(field => {
      field.disabled = false;
    });
  };

  const disableFormFields = container => {
    container.classList.add('d-none');
    container.querySelectorAll('input').forEach(field => {
      if (field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
      field.disabled = true;
    });
    container.querySelectorAll('textarea').forEach(field => {
      field.value = '';
      field.disabled = true;
    });
  };

  const page = (
    <div className="row">
      <div className="col-lg-12">
        <form
          name="request-role-access-form"
          id="request-role-acccess-form"
          className="needs-validation"
          method="POST"
          noValidate>
          <div className="card form-card">
            {/* CARD HEADER */}
            <div className="card-header">Request Access to Marketplace Purchasing Role</div>

            {/* CARD BODY */}
            <div className="card-body">
              {/* Infobox */}
              <div id="infobox" className="card infobox">
                <div className="card-body">
                  <p>For compliance reasons we have to limit the access to the AWS Marketplace.</p>
                  <p>
                    With this form you can request 24h temporary access to a special purchasing role{' '}
                    <code>BMWPurchasing</code> in your target AWS account. You must login with AWS SSO Portal to access
                    this identity center role in the account. This IAM role has limited access and only allows you to
                    use the AWS Marketplace. After 24h your access will be automatically removed again. You'll get an
                    email notification once you get access to the IAM role and another time when you lost it again.
                  </p>
                  <p>
                    Reserved instances for AWS Services like RDS, OpenSearch, ElastiCache, OpenSearch, ElastiCache must
                    be ordered through{' '}
                    <a href="https://atc.bmwgroup.net/confluence/x/1Q8yuwE" target="_blank">
                      CLEA - Reserved instance
                    </a>
                  </p>
                  <p>
                    Find more information in the{' '}
                    <a
                      href="https://developer.bmwgroup.net/docs/public-cloud-platform-aws/1_beforeyoustart/platformdoc/marketplace/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Developer Portal - AWS Marketplace">
                      Developer Portal
                      <i className="px-1 fas fa-external-link-alt" />
                    </a>
                  </p>
                  <p>
                    Ordering of Amazon Bedrock LLM Models is no longer supported via AWS Marketplace. Please get in
                    touch with FG-221 or use the{' '}
                    <a href="https://pages.atc-github.azure.cloud.bmw/Data-Transformation-AI/llm-api/" target="_blank">
                      GAIA General LLM API
                    </a>
                  </p>
                </div>
              </div>
              <div id="fs-infobox" className="card infobox" hidden>
                <div className="card-body">
                  <b>SF Cloud Readiness Process</b>
                  <p>
                    For Financial Services the{' '}
                    <a href="https://atc.bmwgroup.net/confluence/display/CLOUDSF/" target="_blank">
                      SF Cloud Readiness process
                      <i className="px-1 fas fa-external-link-alt" />
                    </a>
                    must be followed before buying marketplace solutions.
                  </p>
                </div>
              </div>
              <div id="request-role-form-container">
                <input type="hidden" id="action" name="action" value="grant-purchase-role" />

                {/* AWS Account */}
                <div className="row">
                  <label for="account_id" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">AWS Account</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <AccountDropdown id="account_id" label="none" onchange={contentVisibilityHandler} short lookup />
                    <div class="invalid-feedback">You must select an option.</div>
                  </div>
                </div>

                {/* Email / Assign to */}
                <div className="row">
                  <label for="email" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Assign to</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <UserDropdown label="none" selectedValues={[]} disableUrlParams id="email" />
                    <div class="invalid-feedback">You must select an option.</div>
                  </div>
                </div>

                {/* Services */}
                <div
                  id="dropdown-marketplace"
                  className="dynamic-form-container row mb-3 skip-on-always-approve d-none">
                  <label for="services" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Services</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <div className="form-group portal-dropdown">
                      <div className="col input-group">
                        <select
                          required
                          className="form-control form-select selectpicker dynamic-form-element"
                          data-live-search="true"
                          data-show-subtext="true"
                          id="services"
                          name="services"
                          data-size="10"
                          onchange={evt => {
                            evt.target.setCustomValidity('');
                            const selection = $(evt.target).selectpicker('val');
                            if (selection === 'not-listed') {
                              enableFormFields(document.getElementById('service-name-container'));
                              disableFormFields(document.getElementById('reason-container'));
                              swal({
                                content: (
                                  <div>
                                    <p align="left">
                                      Dear Customers,
                                      <br />
                                      If you did not find the product on the list, please read our documentation about
                                      adding a new product to the Private Marketplace. Whitelist:{' '}
                                      <a
                                        href="https://developer.bmwgroup.net/docs/public-cloud-platform-aws/1_beforeyoustart/platformdoc/marketplace/activating_new_product/3_activating_new_product/"
                                        target="_blank">
                                        https://developer.bmwgroup.net/docs/public-cloud-platform-aws/1_beforeyoustart/platformdoc/marketplace/activating_new_product/3_activating_new_product/
                                      </a>
                                      <br />
                                      BR,
                                      <br />
                                      Cloud Foundation Team
                                    </p>
                                  </div>
                                ),
                                icon: 'info',
                                buttons: {
                                  reload: {
                                    text: 'OK',
                                    value: true,
                                    visible: true,
                                  },
                                },
                              });
                            } else {
                              disableFormFields(document.getElementById('service-name-container'));
                              document.getElementById('reason-container').classList.remove('d-none');
                              enableFormFields(document.getElementById('form-marketplace'));
                              enableFormFields(document.getElementById('form-reason'));
                              enableFormFields(document.getElementById('costs-marketplace'));
                            }
                          }}>
                          <option className="defaultDisabled" disabled selected>
                            - Select Services -
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Service Name */}
                <div id="service-name-container" className="form-group row d-none dynamic-form-container">
                  <label className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Service Name</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <input
                      type="text"
                      id="service_name"
                      name="service_name"
                      className="form-control dynamic-form-element"
                      placeholder="Name of not yet whitelisted Service"
                      required
                      disabled
                    />
                    <div class="invalid-feedback">You must provide the name of the service.</div>
                  </div>
                </div>

                {/* Reason */}
                <div id="reason-container" className="form-group row skip-on-always-approve d-none">
                  <label className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Reason</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <div
                      id="form-marketplace"
                      data-title="Marketplace"
                      className="form-container dynamic-form-element mb-3 d-none dynamic-form-container">
                      <div>
                        <input
                          type="number"
                          min="0"
                          id="mp_1"
                          name="mp_1"
                          placeholder={questions['Marketplace']['mp_1']}
                          className="form-control form-question-field dynamic-form-element"
                          required
                          disabled
                        />
                        <div class="invalid-feedback">You must provide answers to each question.</div>
                      </div>
                    </div>

                    <div
                      id="form-reason"
                      className="position-relative form-container form-textarea dynamic-form-container"
                      data-title="Other">
                      <textarea
                        required
                        rows="4"
                        id="reason"
                        name="reason"
                        placeholder="Other details necessary to know for approval"
                        className="form-control position-relative form-question-field dynamic-form-element"
                        maxlength="2000"></textarea>
                      <div class="invalid-feedback">You must provide a reason for the purchase.</div>
                      <div className="form-textarea-char-counter">
                        <span className="char-count">0</span>/2000
                      </div>
                    </div>

                    <div
                      id="costs-marketplace"
                      className="form-container mt-3 d-none dynamic-form-container"
                      data-title="Payment Type">
                      <div className="form-check">
                        <input
                          className="form-check-input dynamic-form-element"
                          type="radio"
                          onchange={handleCostsRadioChange}
                          name="costs-marketplace-radio"
                          id="costs-marketplace-per-year"
                          required
                          disabled
                        />
                        <label className="form-check-label" for="costs-marketplace-per-year">
                          Per Year
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input dynamic-form-element"
                          type="radio"
                          onchange={handleCostsRadioChange}
                          name="costs-marketplace-radio"
                          id="costs-marketplace-upfront"
                          required
                          disabled
                        />
                        <label className="form-check-label" for="costs-marketplace-upfront">
                          Upfront
                        </label>
                      </div>
                    </div>

                    <div
                      id="costs-shared"
                      className="form-container dynamic-form-element mt-3 dynamic-form-container d-none"
                      data-title="Estimated Yearly Payment">
                      <input
                        type="text"
                        id="estimated_yearly_payment"
                        name="estimated_yearly_payment"
                        placeholder="Planned yearly costs (No Upfront Payment)"
                        className="form-control form-question-field dynamic-form-element"
                        oninput={evt => {
                          const value = parseInt(evt.target.value);
                          const ekwContainer = document.getElementById('ekw-container');
                          if (value > 10000) {
                            ekwContainer.classList.remove('d-none');
                            ekwContainer
                              .querySelectorAll('input[type="radio"]')
                              .forEach(field => (field.disabled = false));
                          } else {
                            ekwContainer.classList.add('d-none');
                            ekwContainer.querySelectorAll('input').forEach(field => {
                              if (field.type === 'radio') {
                                field.checked = false;
                              } else {
                                field.value = '';
                              }
                              field.disabled = true;
                            });
                          }
                        }}
                        required
                      />
                      <div class="invalid-feedback">You must provide the yearly costs.</div>
                    </div>

                    <div
                      id="ekw-container"
                      className="row dynamic-form-element mt-3 d-none dynamic-form-container"
                      data-title="EKW">
                      <div className="col-md-12 col-lg-6 col-xl-6">
                        <div className="d-flex h-100 flex-row justify-content-between">
                          <div className="px-1 align-self-center mr-4">Do you have an EKW number?</div>
                          <div className="form-check align-self-center mx-4">
                            <input
                              className="form-check-input dynamic-form-element"
                              type="radio"
                              onchange={handleEKWRadioChange}
                              name="ekw-number-radio"
                              id="ekw-number-no"
                              required
                              disabled
                            />
                            <label className="form-check-label" for="ekw-number-no">
                              No
                            </label>
                          </div>
                          <div className="form-check align-self-center mx-4">
                            <input
                              className="form-check-input dynamic-form-element"
                              type="radio"
                              onchange={handleEKWRadioChange}
                              name="ekw-number-radio"
                              id="ekw-number-yes"
                              required
                              disabled
                            />
                            <label className="form-check-label" for="ekw-number-yes">
                              Yes
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 col-lg-6 col-xl-6">
                        <input
                          type="text"
                          id="ekw_number"
                          name="ekw_number"
                          placeholder="EKW number"
                          className="form-control form-question-field dynamic-form-element"
                          required
                          disabled
                        />
                        <div class="invalid-feedback">You must provide your EKW number.</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Date Start */}
                <div className="form-group row skip-on-always-approve d-none">
                  <label for="start_date" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Start</span>
                  </label>
                  <div className="col-md-12 col-lg-5 col-xl-5">
                    <DatePickerField id="start_date" onchange={updateDateValues} />
                    {/* This hidden input is used to  */}
                    <input type="hidden" id="start_date_utc_payload" name="start_date_utc" />
                    <div className="form-description-text" id="start_date_utc"></div>
                  </div>
                  <div className="col-md-12 col-lg-5 col-xl-5">
                    <input
                      type="text"
                      id="start_time"
                      onchange={updateDateValues}
                      onfocus={evt => {
                        evt.target.type = 'time';
                      }}
                      className="form-control"
                    />
                  </div>
                </div>

                {/* Date Till */}
                <div className="form-group row skip-on-always-approve d-none">
                  <label for="start_date" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">End</span>
                  </label>
                  <div className="col-md-12 col-lg-5 col-xl-5">
                    <DatePickerField id="end_date" disabled />
                    <input type="hidden" name="end_date" disabled />
                    <div className="form-description-text" id="end_date_utc"></div>
                  </div>
                  <div className="col-md-12 col-lg-5 col-xl-5">
                    <input type="text" id="end_time" className="form-control" disabled />
                  </div>
                </div>

                {/* Hours */}
                <div className="form-group row d-none">
                  <label for="hours" className="col-md-12 col-lg-2 col-xl-2 form-label-text">
                    <span className="float-md-start float-lg-end mx-xl-3">Hours</span>
                  </label>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <input type="number" id="hours" name="hours" value="24" className="form-control" min="1" max="24" />
                  </div>
                </div>

                <div className="form-group row skip-on-always-approve d-none">
                  <div for="hours" className="col-md-12 col-lg-2 col-xl-2 form-label-text"></div>
                  <div className="col-md-12 col-lg-10 col-xl-10">
                    <div class="alert alert-primary" role="alert">
                      The start and end date refers to the activation of the BMWPurchasing role. If it is active, you
                      still need to switch to the role in the AWS SSO portal before making the purchase.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* CARD FOOTER */}
            <div className="card-footer">
              <div className="row px-2">
                <div className="col">
                  <button type="button" id="resetButton" className="btn btn-secondary" onclick={resetForm}>
                    Reset
                  </button>
                </div>
                <div className="col" align="right">
                  <button type="submit" id="submitButton" className="btn btn-success">
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    Request Permissions
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );

  async function onPageReady() {
    disableFeatureFlagControlledElements('grant-purchase-role.always_approve', 'skip-on-always-approve');
    const isAlwaysApprove = await get_feature_flag_property('grant-purchase-role.always_approve', false);
    setInitialDateValues();

    document.querySelectorAll('input').forEach(field => field.addEventListener('input', resetFieldValidity));
    document.querySelectorAll('textarea').forEach(field => field.addEventListener('input', resetFieldValidity));

    // initialize reason text field and char counter
    const reasonFormField = document.getElementById('reason');
    const reasonCharCount = document.querySelector('.form-textarea-char-counter > .char-count');
    let charCount = 0;
    const debounceEvent =
      (fct, time = 100, timeout) =>
      parameter =>
        clearTimeout(timeout, (timeout = setTimeout(fct, time, parameter)));
    const updateCharCount = () => {
      charCount = reasonFormField.value.length;
      reasonCharCount.innerText = charCount;
    };
    const keypressCounter = evt => {
      charCount += evt.key.length === 1 || -1 * (evt.key.length === 9);
      if (charCount <= 2000) {
        if (charCount < 0) charCount = 0;
        reasonCharCount.innerText = charCount;
      }
    };
    var debouncedUpdateCharCount = debounceEvent(updateCharCount, 500);
    reasonFormField.addEventListener('input', debouncedUpdateCharCount, false);
    reasonFormField.addEventListener('keyup', keypressCounter, false);

    // get whitelisted marketplace products from the backend
    const servicesDropdown = document.getElementById('services');
    console.log('isAlwaysApprove', isAlwaysApprove);
    if (!isAlwaysApprove && servicesDropdown) {
      addSpinner();
      baseApiAxios
        .getWhitelistedServices()
        .then(marketplaceResult => {
          $(servicesDropdown).append(
            <option value="not-listed" data-subtext="Service is not yet whitelisted">
              Not on the list
            </option>,
          );
          if (marketplaceResult.services && marketplaceResult.services.listingsByProductIds) {
            marketplaceResult.services.listingsByProductIds.forEach(serviceOption => {
              if (serviceOption) {
                const displayAttrs = serviceOption.summary.displayAttributes;
                $(servicesDropdown).append(<option value={displayAttrs.title}>{displayAttrs.title}</option>);
              }
            });
          }
          updateSelectPickers();
        })
        .catch(orderError => {
          showError(orderError);
        })
        .finally(() => {
          removeSpinners();
        });
    }

    updateSelectPickers();

    // Initialize the form
    const form = document.querySelector('form[name="request-role-access-form"]');
    form.addEventListener('submit', evt => {
      evt.preventDefault();
      evt.stopPropagation();

      const formData = new FormData(form);
      let orderPayload = Array.from(formData.entries()).reduce((memo, [key, value]) => {
        return {
          ...memo,
          [key]: memo[key] ? (Array.isArray(memo[key]) ? [...memo[key], value] : [memo[key], value]) : value,
        };
      }, {});

      if (isAlwaysApprove) {
        orderPayload['services'] = 'not-listed';
        orderPayload['service_name'] = 'not-listed';
        orderPayload['reason'] =
          'Order will be automatically approved. always_approve flag is set to true via Feature Flag.';
        // when always_approve is set to on , there won't be a start/end date input in the UI , so we use the default of 30 minutes into the future.
        // and it's actually 31 minutes because when the backend validates this timestamp, it would've been a few seconds after the UI sends the request.
        // So this is to avoid declined orders due to start_date_utc being less than 30 minutes in the future.
        const startDate = new Date(new Date().getTime() + 31 * 60 * 1000);
        orderPayload['start_date_utc'] = startDate.toISOString().replace(/\.\d{3}Z/, 'Z');
      }

      if (orderPayload['services']) {
        if (orderPayload['services'] !== 'not-listed') {
          orderPayload['service_name'] = orderPayload['services'];
          orderPayload['service_name_in_list'] = true;
        } else {
          orderPayload['service_name_in_list'] = false;
        }
      }

      orderPayload['estimated_yearly_payment'] = parseInt(orderPayload['estimated_yearly_payment']) || 0;
      orderPayload['upfront_payment'] = isAlwaysApprove ? true : upfrontPayment;

      let deleteKeys = [];

      const questionsArray = Object.entries(questions['Marketplace'] || {});
      questionsArray.forEach(([key, _question]) => {
        if (['mp_1'].indexOf(key) !== -1) {
          orderPayload['duration'] = orderPayload[key];
        }
        deleteKeys.push(key);
      });

      ['ekw-number-radio', 'costs-marketplace-radio', 'services'].concat(deleteKeys).forEach(deleteKey => {
        delete orderPayload[deleteKey];
      });

      form.classList.add('was-validated');

      if (!isAlwaysApprove && !form.checkValidity()) {
        form.reportValidity();
        console.log('invalid form values');
        return;
      }

      orderPayload['description'] = `Grant Marketplace purchasing role for account ${orderPayload['account_id']}`;

      addSpinner();
      addButtonSpinner();
      //Create the order and show a toast with the response message
      baseApiAxios
        .createOrder(orderPayload)
        .then(orderResponse => {
          addToast('Create Order', orderResponse.message, 6000);
        })
        .catch(orderError => {
          showError(orderError);
        })
        .finally(() => {
          resetForm(form);
          removeSpinners();
        });
    });
  }

  return [page, onPageReady];
}
